/**
 * Browser entry point for Feynman
 *
 * This module exports the parser and renderers for use in the browser playground.
 */

export { Parser } from './parser/parser';
export { HtmlRenderer } from './renderer/html/HtmlRenderer';
export { SvgBuilder } from './renderer/html/svg/SvgBuilder';
export { AnimationStateManager } from './renderer/state/AnimationStateManager';

export type { AnimationSequence } from './parser/types';
export type { HtmlRendererOptions } from './renderer/html/HtmlRenderer';
export type { SvgBuilderOptions } from './renderer/html/svg/SvgBuilder';
